// extracted by mini-css-extract-plugin
export default {"ldsRing":"CircleLoader_ldsRing__X0gwZ"};